"use client";
import { BettorNewLeaderboard, Sport } from "common";
import React from "react";
import LeaderboardFilter, { LeaderboardSearchParams } from "./filter";
import Card from "@/components/primitives/card";
import LeaderboardTable from "./table";
import LeaderboardGuide from "./guide";
import NotFound from "@/components/primitives/not-found";
import { useRouter } from "next-nprogress-bar";
import { useQueryUpdater } from "@/utils/hooks/navigation";

export default function LeaderboardContainer({
  sport,
  data,
  searchParams,
}: {
  sport?: Sport;
  data: BettorNewLeaderboard;
  searchParams: LeaderboardSearchParams;
}) {
  const router = useRouter();
  const { createQueryParamString, updateMultipleQueryParams } = useQueryUpdater();
  const onPageChange = (newPage: number) => {
    router.replace(createQueryParamString("page", newPage.toString()), {
      scroll: false,
    });
  };

  const onPageSizeChange = (newSize: number) => {
    const updatedUrl = updateMultipleQueryParams({
      limit: newSize.toString(),
      page: "1"
    });
    router.replace(updatedUrl, { scroll: false });
  };
  return (
    <div className="container">
      <Card.Group
        header={{
          headline: `${sport ? sport : "Global"} Leaderboard`,
          subtitle: "Moneyline",
          action: <LeaderboardFilter searchParams={searchParams} />,
        }}
      >
        <Card>
          {data.bettors && data.bettors.length > 0 ? (
            <LeaderboardTable
              data={data.bettors}
              disableLastPicks
              pagination={{
                size: Number(searchParams.limit || 10),
                page: Number(searchParams.page || 1),
                count: data?.pagination.totalCount || 0,
                onPageChange: onPageChange,
                onPageSizeChange: onPageSizeChange,
              }}
            />
          ) : (
            <NotFound label="No top pickers yet." icon="ticket-buy" />
          )}
        </Card>
        <LeaderboardGuide />
      </Card.Group>
    </div>
  );
}
